export const SAVE_NEWS_FEED_SCROLL = 'SAVE_NEWS_FEED_SCROLL';
export const SAVE_LAWS_FEED_SCROLL = 'SAVE_LAWS_FEED_SCROLL';
export const SAVE_DIGESTS_FEED_SCROLL = 'SAVE_DIGESTS_FEED_SCROLL';



// WEBPACK FOOTER //
// ./src/redux_related/savedScrolls/actions.js